import React from "react";

import { Button, Typography } from "@braintrust/braintrust-ui-components";
import { RouterLink } from "@js/components/link";

import style from "./style.module.scss";

type CantManageMessageProps = {
  title: string;
  to: string;
};

export const CantManageMessage = ({ title, to }: CantManageMessageProps) => {
  return (
    <div className={style.cantManageMessage} data-testid="cant-manage-message">
      <Typography component="h2" sx={{ mb: 4 }}>
        {title}
      </Typography>
      <div>
        <Button variant="primary" to={to} RouterLink={RouterLink}>
          Go to job details page
        </Button>
      </div>
    </div>
  );
};
